/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

function initNotes () {
  if ($(window).width() > 900) {
    return
  }

  $('.block-article.has-notes').each(function () {
    const article = $(this)
    const h2 = article.find('h2')
    if (h2.length) {
      article.find('.article-notes').first().insertAfter(h2.first())
      h2.first().append('<a class="article-notes-toggle"><svg width="9" height="9" xmlns="http://www.w3.org/2000/svg"><path d="M.5 0H9v8.5H7.5v-6L1 9 0 8l6.5-6.5h-6z" fill="currentColor" fill-rule="evenodd"/></svg></a>')
    } else {
      article.prepend('<a class="article-notes-toggle"><svg width="9" height="9" xmlns="http://www.w3.org/2000/svg"><path d="M.5 0H9v8.5H7.5v-6L1 9 0 8l6.5-6.5h-6z" fill="currentColor" fill-rule="evenodd"/></svg></a>')
    }
    article.find('.article-notes-toggle').click(function () {
      article.toggleClass('notes-open')
    })
  })
}

initNotes()
$(document).on('pjax:end', initNotes)
